export default __webpack_public_path__ + "static/media/ATIL.a95aca4f.png";